import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPhotoToPaintingConfig } from '@/data/landingConfig/landingPhotoToPaintingConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PhotoToPainting } from './schemaObject';

interface Props {}
const PhotoToPainting: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PhotoToPainting} />
			<LandingTemplate
				data={landingPhotoToPaintingConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default PhotoToPainting;
